export default __webpack_public_path__ + "static/media/sounds/daze_ready_instructions_alyx.mp3";